import { create } from 'zustand'
import { combine, devtools } from 'zustand/middleware'

export const useNavStore = create(
  devtools(
    combine({ open: false, pinned: false }, (set) => ({
      setOpen: (nextOpen: boolean | ((currentOpen: boolean) => boolean)) => {
        set((state) => ({
          open:
            typeof nextOpen === 'function' ? nextOpen(state.open) : nextOpen,
        }))
      },
      setPinned: (
        nextPinned: boolean | ((currentPinned: boolean) => boolean)
      ) => {
        set((state) => ({
          pinned:
            typeof nextPinned === 'function'
              ? nextPinned(state.pinned)
              : nextPinned,
        }))
      },
    }))
  )
)
